module.exports = __webpack_public_path__ + "static/media/mv.a99b3a3e.svg";